var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 84,
    viewBox: "0 0 75 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 28V42.0035H9.375V63H6.25V73.5H56.25L65.625 73.5035V73.5H68.75V63H65.625V42.0035H68.75V28L37.5 7L6.25 28ZM18.75 63V42.0035H25V63H18.75ZM34.375 63V42.0035H40.625V63H34.375ZM56.25 63H50V42.0035H56.25V63ZM43.75 28C43.7498 28.9195 43.5879 29.8299 43.2735 30.6793C42.9592 31.5287 42.4985 32.3005 41.9179 32.9505C41.3372 33.6005 40.6479 34.116 39.8894 34.4677C39.1308 34.8194 38.3178 35.0002 37.4969 35C36.6759 34.9998 35.863 34.8184 35.1046 34.4664C34.3462 34.1143 33.6572 33.5983 33.0768 32.948C32.4964 32.2977 32.0361 31.5257 31.7221 30.6761C31.4082 29.8265 31.2467 28.916 31.2469 27.9965C31.2473 26.1395 31.9063 24.3588 33.079 23.046C34.2517 21.7333 35.842 20.996 37.5 20.9965C39.158 20.997 40.748 21.7351 41.9201 23.0485C43.0922 24.3619 43.7504 26.143 43.75 28Z",
    fill: "#FF9A02"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.f7f273de8e29a29296db49d9ad6b7f07.svg";
export { ForwardRef as ReactComponent };